import styled, { css } from 'styled-components';
import { COLORS } from '../../constants/style/color';
import { getViewHeight, rem } from '../../utils/style';

interface ModalType {
  size: 'sm' | 'md' | 'lg' | 'xl' | 'xxl' | 'xxxl';
  showNotify: boolean;
}

interface ModalContainerType {
  showNotify: boolean;
}

interface ModelBodyType {
  showNotify: boolean;
  showFooter: boolean;
  subTitle?: boolean;
}

export const ModelContainer = styled.div<ModalContainerType>`
  .backdrop {
    z-index: 999;
    position: fixed;
    top: ${(props) => (props.showNotify ? '67px' : '67px')};
    left: 0;
    width: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    background: ${COLORS.ModalBackdrop};
    height: 100%;

    &.active {
      z-index: 1300;
    }
  }
`;

export const PopoverModelWrapper = styled.div`
  position: relative;
  display: inline-block;

  .title {
    cursor: pointer;
    display: inline-block;

    &:hover,
    &.active {
      font-weight: 500;
      color: ${COLORS.Iris};
      text-decoration: underline;
    }
  }
`;

export const ModelBody = styled.div<ModelBodyType>`
  padding: 2.4rem 3.2rem;
  height: ${(props) =>
    props.showNotify && props.showFooter && props?.subTitle
      ? `${getViewHeight('270px')}`
      : props.showNotify && props.showFooter
      ? `${getViewHeight('253px')}`
      : props.showNotify && !props.showFooter
      ? `${getViewHeight('170px')}`
      : !props.showNotify && props.showFooter && props?.subTitle
      ? `${getViewHeight('280px')}`
      : !props.showNotify && props.showFooter
      ? `${getViewHeight('253px')}`
      : `${getViewHeight('170px')}`};
  overflow-y: auto;

  .borderTop {
    margin-top: 24px;
    padding-top: ${rem(24)};
    border-top: ${rem(1)} solid ${COLORS.CulturedWhite};
  }

  ::-webkit-scrollbar {
    width: 5px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 7px;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: ${COLORS.SpanishGray};
    border-radius: 7px;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: #555;
  }

  .form-title-small {
    font-weight: 500;
    font-size: 12px;
    line-height: 18px;
    color: ${COLORS.Gray60};
    padding-bottom: 5px;
  }

  .table-wrapper {
    & > div:last-child {
      border-bottom: none;
    }
  }
  .roleTitle {
    margin-top: ${rem(32)};
  }

  .roleSubTitle {
    color: ${COLORS.Silver};
    justify-content: center;
    font-weight: 500;
  }

  .participantBlock {
    margin-bottom: 35px;
  }

  .form-title-small {
    font-weight: 500;
    font-size: 12px;
    line-height: 18px;
    color: ${COLORS.Gray60};
    padding-bottom: 5px;
  }
`;

export const PopoverModelContainer = styled.div`
  background-color: ${COLORS.White};
  border-radius: 6px;
  box-shadow: ${rem(0)} ${rem(2)} ${rem(20)} ${COLORS.SoftShadow};
  padding: ${rem(18)};
  z-index: 10;
`;

export const PopupContainer = styled.div`
  .popupDialog {
    min-height: ${getViewHeight('3.5rem')};
    position: relative;
    display: flex;
    align-items: center;
    margin: 1.75rem auto;
    justify-content: center;
  }

  .content {
    width: 100%;
    margin: 0.5rem;
    background: ${COLORS.White};
    box-shadow: 0px 2px 7px rgba(210, 210, 210, 0.28);
    border-radius: 6px;
    @media screen and (min-width: 576px) {
      max-width: 515px;
      margin: 1.75rem auto;
    }
  }
`;

export const ModelStyle = styled.div<ModalType>`
  position: relative;
  background: ${COLORS.White};
  height: auto;
  width: calc(100% - 16px);
  display: flex;
  flex-direction: column;

  border-radius: ${rem(10)};
  margin: ${rem(16)};

  .icon-color {
    color: ${COLORS.Silver};
  }

  @media (min-width: 768px) {
    margin: ${rem(16)} ${rem(16)} ${rem(16)} auto;
  }

  ${(props) => {
    if (props.size === 'sm') {
      return css`
        @media (min-width: 768px) {
          width: 400px;
        }
      `;
    }
    if (props.size === 'md') {
      return css`
        @media (min-width: 768px) {
          width: 500px;
        }
      `;
    }
    if (props.size === 'lg') {
      return css`
        @media (min-width: 768px) {
          width: 700px;
        }
      `;
    }

    if (props.size === 'xl') {
      return css`
        @media (min-width: 768px) {
          width: 700px;
        }

        @media (min-width: 1024px) {
          width: 800px;
        }
      `;
    }
    if (props.size === 'xxl') {
      return css`
        @media (min-width: 768px) {
          width: 700px;
        }

        @media (min-width: 1024px) {
          width: 900px;
        }
      `;
    }
  }};

  .cross-icon {
    color: ${COLORS.Silver};
  }

  .modal-heading {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: ${rem(1)} solid ${COLORS.CulturedWhite};
    padding: ${rem(24)} ${rem(32)} ${rem(21)} ${rem(32)};

    .header-text {
      flex-direction: column;
    }
    h4 {
      font-weight: 500;
      margin-bottom: ${rem(8)};
    }
  }

  .modal-body {
    position: relative;

    .modal-loader {
      /* min-height: ${getViewHeight('169px')}; */
      min-height: ${(props) =>
        props.showNotify ? `${getViewHeight('170px')}` : `${getViewHeight('170px')}`};
      display: flex;
      justify-content: center;
      align-items: center;

      /* &.modal-loader-notify {
        min-height: ${getViewHeight('204px')};
      } */
    }

    ::-webkit-scrollbar {
      width: 5px;
    }

    /* Track */
    ::-webkit-scrollbar-track {
      background: #f1f1f1;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
      background: ${COLORS.SpanishGray};
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
      background: #555;
    }
  }

  .modal-close {
    display: flex;
    align-items: center;
    column-gap: ${rem(2)};
    cursor: pointer;
    span {
      transition: all 0.5s 0s ease;
    }
    &:hover {
      span {
        color: ${COLORS.Red};
      }
    }
  }
`;
export const ModelContentHeading = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: ${rem(24)};
  border-bottom: ${rem(1)} solid ${COLORS.CulturedWhite};
  padding-bottom: ${rem(21)};
  position: relative;
`;
export const ModelHeadingClose = styled.div`
  display: flex;
  align-items: center;
  column-gap: ${rem(2)};
  cursor: pointer;
  span {
    color: ${COLORS.Silver};
  }
`;
export const ModelFooter = styled.div`
  box-sizing: border-box;
  width: 100%;
  right: 0;
  bottom: 0;
  border-top: ${rem(1)} solid ${COLORS.CulturedWhite};
  background-color: ${COLORS.White};
  padding: ${rem(35)} 0;
  border-bottom-right-radius: 1rem;
  border-bottom-left-radius: 1rem;

  .footer-button {
    display: flex;
    justify-content: space-between;
    padding: 0px 32px;
    align-items: center;
  }

  @media (min-width: 512px) {
    padding: ${rem(15)} 0;
  }
`;

// Add Admin User Css
export const ModelContent = styled.div`
  p {
    margin: 0;
    font-weight: 500;
    font-size: 12px;
    line-height: 18px;
    color: ${COLORS.Gray50};
  }
`;

export const Grid = styled.div`
  gap: 20px;
  border-top: 1px solid ${COLORS.Gray50};
  padding-top: 16px;
`;

// Add Role Css
export const Title = styled.h6`
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  line-height: 30px;
  color: ${COLORS.Blue};
`;

export const AlertModal = styled.div`
  h5 {
    font-size: 18px;
    color: ${COLORS.Blue};
    font-weight: 600;
    margin: 10px 0 20px 0;
  }

  h6 {
    color: ${COLORS.Gray90};
    font-size: 15px;
    margin-bottom: 50px;
  }
`;

export const PopoverContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${rem(24)};

  .tag {
    margin-bottom: ${rem(12)};
  }

  .content {
    grid-column-gap: ${rem(60)};

    .title {
      color: ${COLORS.Gray};
      margin-bottom: ${rem(4)};
    }

    .comma-text {
      padding-right: 2px;
    }

    .only-text {
      padding-left: 2px;
    }
  }
`;

export const ClearNotificationButton = styled.div`
  background: ${COLORS.CulturedWhite};
  border-radius: 35px;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  padding: 5px 18px;
  cursor: pointer;
`;
